import { render, staticRenderFns } from "./Detalhes_Eventos.vue?vue&type=template&id=70df3a3a&scoped=true&"
import script from "./Detalhes_Eventos.vue?vue&type=script&lang=js&"
export * from "./Detalhes_Eventos.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes_Eventos.vue?vue&type=style&index=0&id=70df3a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df3a3a",
  null
  
)

export default component.exports